const ANALYZE_SEARCH_EVENT = 'ANALYZE_SEARCH_EVENT';
const ANALYZE_SEARCH_FILTER_CHANGE = 'ANALYZE_SEARCH_FILTER_CHANGE';
const ANALYZE_SEARCH_FILTER_RESULTS = 'ANALYZE_SEARCH_FILTER_RESULTS';
const ANALYZE_SEARCH_PAGE_VIEW = 'ANALYZE_SEARCH_PAGE_VIEW';
const ANALYZE_SEARCH_RESULT_PRODUCT_CLICK = 'ANALYZE_SEARCH_RESULT_PRODUCT_CLICK';
const ANALYZE_SEARCH_RESULT_PRODUCT_INSERT_EVENT = 'ANALYZE_SEARCH_RESULT_PRODUCT_INSERT_EVENT';
const ANALYZE_SIMILAR_SEARCH_QUERY = 'ANALYZE_SIMILAR_SEARCH_QUERY';
const ANALYZE_SUGGESTED_CATEGORY_SEARCH = 'ANALYZE_SUGGESTED_CATEGORY_SEARCH';
const ANALYZE_SUGGESTED_SEARCH_RESULT_PRODUCT_CLICK = 'ANALYZE_SUGGESTED_SEARCH_RESULT_PRODUCT_CLICK';

export {
  ANALYZE_SEARCH_EVENT,
  ANALYZE_SEARCH_FILTER_CHANGE,
  ANALYZE_SEARCH_FILTER_RESULTS,
  ANALYZE_SEARCH_PAGE_VIEW,
  ANALYZE_SEARCH_RESULT_PRODUCT_CLICK,
  ANALYZE_SEARCH_RESULT_PRODUCT_INSERT_EVENT,
  ANALYZE_SIMILAR_SEARCH_QUERY,
  ANALYZE_SUGGESTED_CATEGORY_SEARCH,
  ANALYZE_SUGGESTED_SEARCH_RESULT_PRODUCT_CLICK,
};
